import React from 'react'

import RolesPanel from './RolesPanel'

const RolesTab = ({ admin: { roles } }) => (
  <div className='role-view'>
    <div className='children-view'>
      <RolesPanel roles={roles} />
    </div>
  </div>
)

export default RolesTab
